// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thank-you-container {
    text-align: center;
    padding: 40px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    margin: 50px auto;
    margin-top: 160px;
}

h2 {
    font-size: 24px;
    color: #333;
    margin-top: 10px;
}

p {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
}

/* Checkmark Animation */
.checkmark-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.checkmark {
    width: 60px;
    height: 60px;
}

.checkmark-circle {
    fill: none;
    stroke: #4caf50;
    stroke-width: 4;
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-linecap: round;
    animation: drawCircle 1s ease-out forwards;
}

.checkmark-check {
    stroke: #4caf50;
    stroke-width: 4;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: drawCheck 0.5s 1s ease-out forwards;
}

@keyframes drawCircle {
    to {
        stroke-dashoffset: 0;
    }
}

@keyframes drawCheck {
    to {
        stroke-dashoffset: 0;
    }
}

/* Button */
.continue-btn {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s ease-in-out;
}

.continue-btn:hover {
    background-color: #388e3c;
}`, "",{"version":3,"sources":["webpack://./src/Styles/ThankYouMessage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".thank-you-container {\n    text-align: center;\n    padding: 40px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    margin: 50px auto;\n    margin-top: 160px;\n}\n\nh2 {\n    font-size: 24px;\n    color: #333;\n    margin-top: 10px;\n}\n\np {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 20px;\n}\n\n/* Checkmark Animation */\n.checkmark-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.checkmark {\n    width: 60px;\n    height: 60px;\n}\n\n.checkmark-circle {\n    fill: none;\n    stroke: #4caf50;\n    stroke-width: 4;\n    stroke-dasharray: 166;\n    stroke-dashoffset: 166;\n    stroke-linecap: round;\n    animation: drawCircle 1s ease-out forwards;\n}\n\n.checkmark-check {\n    stroke: #4caf50;\n    stroke-width: 4;\n    stroke-dasharray: 48;\n    stroke-dashoffset: 48;\n    animation: drawCheck 0.5s 1s ease-out forwards;\n}\n\n@keyframes drawCircle {\n    to {\n        stroke-dashoffset: 0;\n    }\n}\n\n@keyframes drawCheck {\n    to {\n        stroke-dashoffset: 0;\n    }\n}\n\n/* Button */\n.continue-btn {\n    background-color: #4caf50;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: 0.3s ease-in-out;\n}\n\n.continue-btn:hover {\n    background-color: #388e3c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
